import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { loginCheck } from "../../functions/auth"
import { toast } from "react-toastify"
import { useSelector } from 'react-redux';
// import { LeafPoll } from 'react-leaf-polls';
// import 'react-leaf-polls/dist/index.css'

import Vote from "./Vote";

const useStyles = makeStyles({
    root: {
        width: "400px",
        margin: 10,
        borderRadius: 10,
        "@media(max-width:770px)": {
            width: "100%",
            // width: "90%"
        }
    },

    container: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
    },

    title: {
        whiteSpace: "nowrap",
    },


    box1: {
        width: "150px",
        height: "120px",
        backgroundColor: "#C9F7F2",
        borderRadius: "20px",
        textAlign: "center",
        lineHeight: "120px",
        margin: "5px",
        fontWeight: "bold",
    },

    box2: {
        width: "150px",
        height: "120px",
        backgroundColor: "#B6E9ED",
        borderRadius: "20px",
        textAlign: "center",
        lineHeight: "120px",
        margin: "5px",
        fontWeight: "bold",
    },

    box3: {
        width: "110px",
        height: "120px",
        backgroundColor: "#c9F7F2",
        borderRadius: "20px",
        textAlign: "center",
        lineHeight: "120px",
        margin: "5px",
        fontWeight: "bold",
    },
    box4: {
        width: "110px",
        height: "120px",
        backgroundColor: "#B6E9ED",
        borderRadius: "20px",
        textAlign: "center",
        lineHeight: "120px",
        margin: "5px",
        fontWeight: "bold",
    },
    box5: {
        width: "150px",
        height: "58px",
        backgroundColor: "#C9F7F2",
        borderRadius: "20px",
        textAlign: "center",
        lineHeight: "56px",
        margin: "2px",
        fontWeight: "bold",
        "@media(max-width:770px)": {
            width: "45%",
        }
    },

    box6: {
        width: "150px",
        height: "58px",
        backgroundColor: "#B6E9ED",
        borderRadius: "20px",
        textAlign: "center",
        lineHeight: "56px",
        margin: "2px",
        fontWeight: "bold",
        "@media(max-width:770px)": {
            width: "45%",
        }

    },

    versus: {
        width: "35px",
        fontSize: "25px",
        position: "absolute",
        textAlign: "center",
        backgroundColor: "white",
        borderRadius: "20px",


    },

    versus1: {
        width: "35px",
        fontSize: "25px",
        position: "absolute",
        textAlign: "center",
        backgroundColor: "white",
        borderRadius: "20px",
        marginRight: "120px"


    },

    versus2: {
        width: "35px",
        fontSize: "25px",
        position: "absolute",
        textAlign: "center",
        backgroundColor: "white",
        borderRadius: "20px",
        marginLeft: "120px"

    },

    plus: {
        position: "absolute",
        borderRadius: "10px",
        backgroundColor: "#C9F7F2",
        width: "30px",
        height: "30px",
        textAlign: "center",
        lineHeight: "30px",
        marginLeft: "350px",
        marginTop: "90px",
        "@media(max-width:770px)": {
            marginLeft: "92%",
            //  marginTop: "20%",
        }
    },

    footer: {
        borderTop: "1px solid #E0E0E0",
        marginTop: "10px",
        paddingTop: "10px"

    },


    heart: {
        marginLeft: 'auto',
        float: 'right',
        padding: '6px',
    }

});

const General = ({ _id, title, content, date, author, comments, likes, participants_userids, polls, done }) => {

    const styles = useStyles();
    const { user } = useSelector(state => ({ ...state }));
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        if (loginCheck() && user) {
            setOpen(true);
        } else {
            toast.error("로그인을 먼저 해주시기 바랍니다.")
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    const options = (data) => {

        if (data.length === 2) {
            return (
                <div className={styles.container}>
                    <div className={styles.box1}>{data[0].content}</div>
                    <div className={styles.versus}>VS</div>
                    <div className={styles.box2}>
                        {data[1].content}
                    </div>
                </div>
            )
        } else if (data.length === 3) {
            return (
                <div className={styles.container}>
                    <div className={styles.box3}>{data[0].content}</div>
                    <div className={styles.versus1}>VS</div>
                    <div className={styles.box3}>{data[1].content}</div>
                    <div className={styles.versus2}>VS</div>
                    <div className={styles.box3}>{data[2].content}</div>
                </div>
            )
        } else if (data.length === 4) {
            return (
                <div className={styles.container}>
                    <div className={styles.box5} >{data[0].content}</div>
                    <div className={styles.box6}>{data[1].content}</div>
                    <div className={styles.versus}>VS</div>
                    <div className={styles.box6}>{data[2].content}</div>
                    <div className={styles.box5}>{data[3].content}</div>
                </div>
            )
        } else {
            return (
                <div className={styles.container}>
                    <div className={styles.box5} >{data[0].content}</div>
                    <div className={styles.box6}>{data[1].content}</div>
                    <div className={styles.versus}>VS</div>
                    <div className={styles.box6}>{data[2].content}</div>
                    <div className={styles.box5}>{data[3].content}</div>
                    <div className={styles.plus}> {`+${data.length - 4}`}</div>
                </div>
            )
        }


    }


    return (

        <> {polls &&
            <>
                <Card className={styles.root} onClick={handleClickOpen}>
                    <CardActionArea>
                        <CardContent>
                            <Typography gutterBottom variant="h6" component="h6" className={styles.title}>
                                {`Q. ${title}`}
                            </Typography>

                            {options(polls)}
                            <div className={styles.footer}>
                                <Button >
                                    {`참여 ${participants_userids.length}명 I 댓글 ${comments.length}개`}
                                </Button>
                                <IconButton className={styles.heart} color="secondary">
                                    <FavoriteBorderIcon />
                                    {`+${likes}`}
                                </IconButton>
                            </div>
                        </CardContent>
                    </CardActionArea>
                </Card>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    fullWidth
                >
                    <DialogTitle id="alert-dialog-title">{`Q. ${title}`}</DialogTitle>
                    <DialogContent>
                        {content}
                    </DialogContent>
                    <DialogContent>
                        <Vote content={polls} author={author} participants_userids={participants_userids} _id={_id} open={open} done={done} />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="primary" autoFocus>
                            닫기
                        </Button>
                    </DialogActions>
                </Dialog>
            </>
        }

        </>

    );
};

export default React.memo(General);